.usersTableSection {
    display: flex;
    flex-direction: column;
    gap: var(--users-table-section-gap);
    width: 100%;
}

.certificationFilter {
    max-width: var(--users-table-section-certification-filter-max-width);
}

.memberName {
    white-space: nowrap;
}

.tableScroll {
    overflow-x: auto;
    width: 100%;
}

.loadMore {
    align-self: center;
}
